import { z } from 'zod';
import { AbstractPostQuoteRequestSchema } from './post-quote.ts';
import { CustomisedQuotePayloadByProductTypeSchema } from './quote-payload.ts';

export const PostQuoteFulfillmentRequestSchema = AbstractPostQuoteRequestSchema.omit({
    callbackUrl: true,
    positionProductId: true,
})
    .merge(
        z.object({
            partnerOrganizationId: z.number().int().positive(),
        })
    )
    .and(CustomisedQuotePayloadByProductTypeSchema);

export type PostQuoteFulfillmentRequest = z.infer<typeof PostQuoteFulfillmentRequestSchema>;
